import React, { ReactElement } from 'react';
import { Box } from '@mui/material';
import PageHeader from 'shared/components/PageHeader';
import { HeadTag } from 'shared/components';
import GuardrailsList from './components/GuardrailsList';

const Guardrails = (): ReactElement => {
  console.log('HELLOS');
  return (
    <>
      <PageHeader
        title="Guardrails"
        description="Configure prompt monitoring policies and MCP proxy enforcement"
      />
      <Box className="guardrails-management guardrails-management manage">
        <HeadTag title="Guardrails" />
        <Box className="guardrails-management-wrapper">
          <GuardrailsList />
        </Box>
      </Box>
    </>
  );
};

export default Guardrails;
